var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"pa-4",attrs:{"data-qa":"services-flex-40pw5f"}},[_vm._v(" "+_vm._s('Services')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }